interface TagProps {
    title: string;
}

const Tag = (props: TagProps) => {
    const { title } = props;
    return (
        <li className="tag-list-item px-3 py-2">
            <span className="font-light">{title}</span>
        </li>
    );
};

export default Tag;
